export const HAS_DEV = process.env.MOCK
  || process.env.DEV
  || process.env.TESTING
  || process.env.RC;

export const DEFAULT_AVATAR_CORP = require('../assets/bg/0000.png');

export const COINS = [
  {id: 'BTC', name: 'Bitcoin (BTC)'},
  {id: 'ETH', name: 'Ethereum (ETH)'},
  {id: 'XRP', name: 'Ripple (XRP)'},
  {id: 'LTC', name: 'Litecoin (LTC)'},
  {id: 'BCH', name: 'Bitcoin Cash (BCH)'},
  {id: 'USDT', name: 'Ethereum (ETH)'},
  {id: 'USDC', name: 'Ethereum (ETH)'},
  {id: 'UNI', name: 'Ethereum (ETH)'},
  {id: 'LINK', name: 'Ethereum (ETH)'},
  {id: 'ALGO', name: 'Algorand (ALGO)'},
  // {id: 'BNB', name: 'Binance (BNB)', disabled: 1, active: 1},
  // {id: 'TRX', name: 'Tron (TRX)', disabled: 1, active: 1},
  /*
  {id: 'DASH', name: 'Dash', disabled: 1},
  {id: 'BTH', name: 'Bitcoin ABC', disabled: 1},
  {id: 'BTCLN', name: 'BTCLN'},
  {id: 'BSV', name: 'Bitcoin SV'},
  {id: 'DASH', name: 'DASH'},
  {id: 'LTC', name: 'LTC'},
  {id: 'EOS', name: 'EOS'},
  {id: 'TRON', name: 'TRON'},
  {id: 'Monero', name: 'Monero'},
  */
];

export const CURRENCY_USD = 'USD';
export const CURRENCY_EUR = 'EUR';
export const CURRENCY_GBP = 'GBP';

export const CURRENCY_ITEMS = [
  {id: CURRENCY_USD, name: 'US dollar'},
  {id: CURRENCY_EUR, name: 'Euro'},
  {id: CURRENCY_GBP, name: 'British pound sterling'},
  {id: 'CHF', name: 'Swiss franc'},
  {id: 'CAD', name: 'Canadian dollar'},
  {id: 'AUD', name: 'Australian dollar'},
  {id: 'SGD', name: 'Singapore dollar'},
  {id: 'JPY', name: 'Japanese yen'},
  {id: 'AED', name: 'Emirati dirham'},
  {id: 'DKK', name: 'Danish krone'},
  {id: 'HKD', name: 'Hong Kong dollar'},
  {id: 'SAR', name: 'Saudi Arabian Riyal'},
  {id: 'PLN', name: 'Polish złoty'},
  {id: 'SEK', name: 'Swedish krona'}, // test

  /*
  {id: '------------', disabled: 1, separator: 1},
  {id: 'BDT', name: 'Bangladeshi taka'},
  {id: 'BHD', name: 'Bahraini dinar'},
  {id: 'BTN', name: 'Bhutanese ngultrum'},
  {id: 'IDR', name: 'Indonesian rupiah'},
  {id: 'ILS', name: 'Israeli new shekel'},
  {id: 'INR', name: 'Indian rupee'},
  {id: 'JOD', name: 'Jordanian dinar'},
  {id: 'KWD', name: 'Kuwaiti dinar'},
  {id: 'LKR', name: 'Sri Lankan rupee'},
  {id: 'MYR', name: 'Malaysian ringgit'},
  {id: 'NPR', name: 'Nepalese rupee'},
  {id: 'OMR', name: 'Omani rial'},
  {id: 'PHP', name: 'Philippine peso'},
  {id: 'PKR', name: 'Pakistani rupee'},
  {id: 'QAR', name: 'Qatari riyal'},
  {id: 'RUB', name: 'Russian ruble'},
  {id: 'SGD', name: 'Singapore dollar'},
  {id: 'THB', name: 'Thai baht'},
  {id: 'TRY', name: 'Turkish lira'},
  {id: 'BAM', name: 'Bosnian convertible mark'},
  {id: 'BGN', name: 'Bulgarian lev'},
  {id: 'CZK', name: 'Czech koruna'},
  {id: 'HRK', name: 'Croatian kuna'},
  {id: 'HUF', name: 'Hungarian forint'},
  {id: 'NOK', name: 'Norwegian krone'},
  {id: 'RON', name: 'Romanian leu'},
  {id: 'RSD', name: 'Serbian dinar'},
  {id: 'UAH', name: 'Ukrainian hryvnia'},
  {id: 'SEK', name: 'Swedish krona'},
  {id: 'BBD', name: 'Barbadian or dollar'},
  {id: 'CRC', name: 'Costa Rican colón'},
  {id: 'DOP', name: 'Dominican peso'},
  {id: 'GTQ', name: 'Guatemalan quetzal'},
  {id: 'HNL', name: 'Honduran lempira'},
  {id: 'JMD', name: 'Jamaican dollar'},
  {id: 'MXN', name: 'Mexican peso'},
  {id: 'TTD', name: 'Trinidad and Tobago dollar'},
  {id: 'XCD', name: 'Eastern Caribbean dollar'},
  {id: 'FJD', name: 'Fijian dollar'},
  {id: 'TOP', name: 'Tongan pa'anga'},
  {id: 'NZD', name: 'New Zealand dollar'},
  {id: 'ETB', name: 'Ethiopian birr'},
  {id: 'GHS', name: 'Ghanaian cedi'},
  {id: 'GMD', name: 'Gambian dalasi'},
  {id: 'GNF', name: 'Guinean franc'},
  {id: 'KES', name: 'Kenyan shilling'},
  {id: 'MAD', name: 'Moroccan dirham'},
  {id: 'MUR', name: 'Mauritian rupee'},
  {id: 'MZN', name: 'Mozambican metical'},
  {id: 'RWF', name: 'Rwandan franc'},
  {id: 'SLL', name: 'Sierra Leonean leone'},
  {id: 'TND', name: 'Tunisian dinar'},
  {id: 'TZS', name: 'Tanzanian shilling'},
  {id: 'ZAR', name: 'South African rand'},
  {id: 'ARS', name: 'Argentine peso'},
  {id: 'BOB', name: 'Bolivian boliviano'},
  {id: 'BRL', name: 'Brazilian real'},
  {id: 'CLP', name: 'Chilean peso'},
  {id: 'COP', name: 'Colombian peso'},
  {id: 'ECS', name: 'Ecuadorian sucre'},
  {id: 'GYD', name: 'Guyanese dollar'},
  {id: 'PYG', name: 'Paraguayan guaraní'},
  {id: 'PEN', name: 'Peruvian sol'},
  {id: 'SRD', name: 'Surinamese dollar'},
  {id: 'UYU', name: 'Uruguayan peso'},
  */
];


export const USER_TYPE_ADMIN = 'Admin';
export const USER_TYPE_MERCHANT = 'Merchant';
export const USER_TYPE_OPERATOR = 'merchant_user';
export const USER_TYPE_CUSTOMER = 'customer';


export const DEFAULT_CURRENCY = CURRENCY_EUR;